import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/:code',
      name: 'search',
      component: () => import('@/components/search')
    },
    {
      path: '/:code/:openid',
      name: 'search',
      component: () => import('@/components/search')
    },
    {
      path: '/form/:openid/:id/:actiontype/:code',
      name: 'form',
      component: () => import('@/components/form')
    },{
      path: '/wechat/error/:msg',
      name: 'error',
      component: () => import('@/components/error')
    },{
      path: '/privacy/privacy_policy/:openid',
      name: 'PrivacyPolicy',
      component: () => import('@/components/PrivacyPolicy.vue')
    },
    {
      path: '/sub/sub/subscribe',
      name: 'subscribe',
      component: () => import('@/components/subscribe.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js